import { render } from "./AddItemToCart.vue?vue&type=template&id=81ccea4c&scoped=true"
import script from "./AddItemToCart.vue?vue&type=script&lang=js"
export * from "./AddItemToCart.vue?vue&type=script&lang=js"

import "./AddItemToCart.vue?vue&type=style&index=0&id=81ccea4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ccea4c"]])

export default __exports__